<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout container align-center justify-center wrap rows>
        <v-flex xs-12>
          <v-card>
            <v-card-title>
              <v-img :src="logo"/>
            </v-card-title>

            <v-card-title primary-title>
              <h1 class="headline">No survey loaded at the moment. Find a link in your inbox to start a survey!</h1>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',

  data () {
    return {
      logo: require('@/assets/leapq-logo.jpg')
    }
  }
}
</script>

<style scoped>
  .v-card {
    padding: 50px;
  }

  .v-image {
    margin: auto;
    max-width: 500px;
  }

  .headline {
    font-size: 36px !important;
    margin: auto;
    text-align: center;
  }
</style>
